export default class BackofficeMondayImportsStats {
  constructor() {
    console.log('BackofficeMondayImportsStats initialized - using simple link-based downloads');
    // No complex logic needed anymore - everything is handled by simple links and Rails
  }

  onDataChanged(data) {
    // Custom logic for data changes if needed
  }

  onDestroy() {
    // Cleanup if needed
  }
}
